// store/actions/addleadotherinformation-action.ts
import { createLeadOtherinfo } from "../../services/AddleadotherinformationService"
import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService" // Assuming this path is correct

export const CONFIRMED_CREATE_LEAD_OTHER_INFO = "CONFIRMED_CREATE_LEAD_OTHER_INFO"

export function createLeadOtherinfoAction(otherInfoData) {
  return async (dispatch) => {
    try {
      const response = await createLeadOtherinfo(otherInfoData)
      if (response?.status === 200 && response.data) {
        dispatch({
          type: CONFIRMED_CREATE_LEAD_OTHER_INFO,
          payload: otherInfoData, // Or response.data if the API returns the created object
        })
        handleSuccess("Other person information saved successfully!")
      } else {
        showErrorAlert("Failed to save other person information")
      }
    } catch (error) {
      console.error("API Error:", error)
      showErrorAlert("Failed to save other person information")
      throw error // Re-throw to allow component to catch if needed
    }
  }
}
